module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.library.js
// module id = 81
// module chunks = 0